// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3KKGZ","search":"Settings_search__2zTua","filter":"Settings_filter__K9RRB"};